import React, { Component } from "react";
import AlumnoTabla from "./AlumnoTabla";
import { connect } from "react-redux";
import { getAlumnoList } from './AlumnoAction'
import { withRouter } from 'react-router-dom';

class AlumnoContainer extends Component {

    componentDidMount() {
        //console.log("AlumnoContainer");
        this.props.dispatch(getAlumnoList());
    }

    render() {
        return (
            <div>
                <AlumnoTabla />
            </div>
        );
    }
}

export default connect()(AlumnoContainer);
